import {
  createContext,
  useContext,
  useMemo,
  type ReactNode,
} from 'react';
import { resolveBrand } from '../../brand';
import { useAuth } from '../hooks/useAuth';

export interface BrandConfig {
  name: string;
  logo?: string;
  logoSquare?: string;
  logoHorizontal?: string;
  colors: {
    primary: string;
    secondary: string;
  };
  documentMeta?: BrandDocumentMeta;
}

export interface BrandDocumentMeta {
  title?: string;
  description?: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
}

const BrandContext = createContext<BrandConfig | undefined>(undefined);

export function BrandProvider({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const brand = useMemo(() => resolveBrand(user?.center), [user?.center]);

  return (
    <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>
  );
}

export const useBrand = () => {
  const context = useContext(BrandContext);
  if (!context) {
    throw new Error('useBrand must be used within a <BrandProvider>');
  }
  return context;
};
